function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#004152",
  fillRule: "evenodd",
  d: "M4.683 12.303c.913 0 1.652.737 1.652 1.644 0 .91-.739 1.645-1.652 1.645-.912 0-1.65-.736-1.65-1.645 0-.908.738-1.644 1.65-1.644zm1.373-6.591c.079-.303.53-.65.845-.65h12.201c.314 0 .765.347.844.65l1.062 4.061H4.993l1.062-4.061zm15.261 6.59c.913 0 1.651.738 1.651 1.645 0 .438-.174.857-.484 1.165-.31.308-.73.481-1.167.48-.437.001-.857-.171-1.167-.48-.31-.308-.484-.727-.485-1.165.001-.437.175-.856.485-1.164.31-.309.73-.481 1.168-.48zm1.574-2.52l-1.184-4.528c-.29-1.102-1.46-2.004-2.606-2.004H6.9c-1.144 0-2.317.902-2.605 2.005L3.11 9.783C1.367 9.88.003 11.32 0 13.065v4.743c0 .91.739 1.645 1.652 1.645h1.135v1.408c0 1.043.85 1.89 1.896 1.89 1.049 0 1.897-.847 1.897-1.889v-1.408h12.84v1.408c0 1.043.848 1.889 1.897 1.889 1.047 0 1.896-.847 1.896-1.889v-1.408h1.135c.912 0 1.652-.737 1.652-1.647v-4.742c-.003-1.745-1.367-3.184-3.11-3.28v-.003z",
  clipRule: "evenodd"
});

var SvgVehicles = function SvgVehicles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVehicles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicles.da9456e7.svg";
export { ForwardRef as ReactComponent };